import React from "react";
import { ErrorList, ErrorStrings } from "../../../components/Enums";
import { FormField, PortalFormFieldGroup, PortalFormLabel, portalColors } from "src/components";
import Skeleton from "src/scenes/Statistics/components/Skeleton";

export const SurveyNameField = (props) => {
    const { survey, inputSurveyName, inputErrors, loading } = props;

    const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
    const surveyNameError = getErrorStrings(ErrorList.EMPTY_SURVEY_NAME);

    return (
        <PortalFormFieldGroup>
            <PortalFormLabel>
                Enter Survey Name
            </PortalFormLabel>
            { loading ?
                <Skeleton height="50px" width="100%" animation="wave" />
                :
                <FormField borderRadius="8px" size="0.9375rem" padding="10px 20px" height="46px"
                    placeholderColor={portalColors.textSoft} border={`1px solid ${portalColors.borderStrong}`}
                    placeholderAlignment="left"
                    width="100%"
                    type="text"
                    style={{ textAlign: "left", margin: "0" }}
                    placeholder="Enter name here"
                    onChange={(event) => { inputSurveyName(event); }}
                    errors={surveyNameError}
                    maxLength="100"
                    value={survey.name}
                    showErrors={surveyNameError.length > 0}
                />
            }
        </PortalFormFieldGroup>
    );
};
